import './styles.scss';

import * as React from 'react';
import { FormattedHTMLMessage, FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import Button from 'src/components/Button';
import { clickUserProfileDeleteAllPagesButton, deleteAccountClick } from '../../containers/UserProfile/actions';

const translationsScope = 'components.Profile.Privacy';

const SecurityAndPrivacy = (props: InjectedIntlProps) => {
  const {
    intl: { formatMessage },
  } = props;

  const dispatch = useDispatch();

  const onDeleteAll = () => {
    const shouldDelete = confirm(
      formatMessage({
        id: `containers.UserProfile.deleteAllDataPrompt`,
      }),
    );

    if (shouldDelete) {
      const successMessage = formatMessage({
        id: `containers.UserProfile.deleteAllDataSuccess`,
      });
      dispatch(clickUserProfileDeleteAllPagesButton(successMessage));
    }
  };

  const onDeleteAccount = () => {
    const shouldDelete = confirm(
      formatMessage({
        id: `containers.UserProfile.deleteAccountPrompt`,
      }),
    );

    if (shouldDelete) {
      const successMessage = formatMessage({
        id: `containers.UserProfile.deleteAccountSuccess`,
      });
      dispatch(deleteAccountClick(successMessage));
    }
  };

  return (
    <div className="SecurityAndPrivacy">
      <div className="SecurityAndPrivacy-title">
        <FormattedMessage id={`${translationsScope}.title`} />
      </div>
      <div className="SecurityAndPrivacy-content">
        <div className="SecurityAndPrivacy-row">
          <div className="SecurityAndPrivacy-column">
            <div className="SecurityAndPrivacy-label">
              <FormattedMessage id={`${translationsScope}.deleteAllData`} />
            </div>
            <div className="SecurityAndPrivacy-value">
              <FormattedHTMLMessage id={`${translationsScope}.deleteAllDataNote`} />
            </div>
          </div>
          <div className="SecurityAndPrivacy-column">
            <div className="SecurityAndPrivacy-button">
              <Button color="orange" outline={true} block={true} onClick={onDeleteAll}>
                <FormattedMessage id={`${translationsScope}.deleteAllData`} />
              </Button>
            </div>
          </div>
        </div>
        <div className="SecurityAndPrivacy-row">
          <div className="SecurityAndPrivacy-column">
            <div className="SecurityAndPrivacy-label">
              <FormattedMessage id={`${translationsScope}.deleteAccount`} />
            </div>
            <div className="SecurityAndPrivacy-value">
              <FormattedHTMLMessage id={`${translationsScope}.deleteAccountNote`} />
            </div>
          </div>
          <div className="SecurityAndPrivacy-column">
            <div className="SecurityAndPrivacy-button">
              <Button color="orange" outline={true} block={true} onClick={onDeleteAccount}>
                <FormattedMessage id={`${translationsScope}.deleteAccount`} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(injectIntl(SecurityAndPrivacy));



// WEBPACK FOOTER //
// ./src/components/SecurityAndPrivacy/index.tsx